// Generated from the reviewed localization source; keep keys aligned with the marketing copy schema.
export const additionalMarketingCopy = {
  "ur": {
    "hero": [
      [
        "MecoPay ایک مکمل ای کامرس حل ہے —",
        "طاقتور پیمنٹ گیٹ ویز کے ساتھ",
        "اور ایک نو-کوڈ ویب سائٹ بلڈر۔"
      ],
      [
        "اپنی کسٹم ویب سائٹ استعمال کریں یا",
        "ہماری نو-کوڈ ویب سائٹ جو API اور لنکس فراہم کرتی ہے",
        "اور سوشل میڈیا پیمنٹ لنکس کے ذریعے ادائیگیاں قبول کریں۔"
      ],
      [
        "چند کلکس میں ویب سائٹ بنائیں،",
        "اپنا کسٹم ڈومین شامل کریں،",
        "اور اپنی ڈیجیٹل شناخت بنائیں۔"
      ],
      [
        "سوشل میڈیا سے خودکار آرڈرز وصول کریں",
        "AI Agent Chatbot کے ذریعے",
        "(نو-کوڈ ویب سائٹ صارفین کے لیے)."
      ],
      [
        "ہمارے پلیٹ فارم میں کورئیر API شامل کریں،",
        "آرڈرز کی ایک کلک میں تصدیق کریں،",
        "اور انہیں براہ راست کورئیر کو بھیج دیں۔"
      ]
    ],
    "features": {
      "no-code-website": [
        "بغیر کسی کوڈنگ کے ای کامرس، تعلیمی، بلاگ یا خبری سائٹس بنائیں اور شائع کریں۔",
        "مثال: کورس فروخت کنندہ کے ڈیش بورڈ سے لینڈنگ پیج اور پروڈکٹ پوسٹ شائع کریں۔"
      ],
      "custom-domain": [
        "اپنا ڈومین کنیکٹ کریں اور تیز روٹنگ کے ساتھ پیشہ ورانہ ڈیجیٹل شناخت بنائیں۔",
        "مثال: آپ کی دکان www.acme.com پر چلتی ہے بجائے پلیٹ فارم کے سب ڈومین کے۔"
      ],
      "capi": [
        "قابلِ اعتماد مہم پیمائش کے لیے کنورژن ایونٹس سرور-سائیڈ بھیجیں۔",
        "مثال: ایک خریداری ایونٹ سرور سے ایڈ پلیٹ فارم کو بھیجا جاتا ہے۔"
      ],
      "personal-mfs": [
        "مخصوص Personal MFS ادائیگیوں کی تصدیق کو خودکار بنائیں۔",
        "مثال: ایک Personal MFS ادائیگی ویب سائٹ آرڈر سے میچ ہو جاتی ہے۔"
      ],
      "local-gateway": [
        "علاقائی صارفین کے لیے مقامی ادائیگی کے طریقے کنیکٹ کریں۔",
        "مثال: ایک مقامی خریدار علاقائی گیٹ وے کے ذریعے چیکآؤٹ مکمل کرتا ہے۔"
      ],
      "international-gateway": [
        "دنیا بھر کے صارفین کے لیے بین الاقوامی ادائیگی کے طریقے کنیکٹ کریں۔",
        "مثال: بیرونِ ملک خریدار عالمی طریقہ استعمال کر کے چیکآؤٹ مکمل کرتا ہے۔"
      ],
      "notifications": [
        "صارفین اور تاجروں کو ادائیگی اور آرڈر اپڈیٹس بھیجیں۔",
        "مثال: ادائیگی کی کامیابی ایک تاجر کو الرٹ اور صارف کو اپڈیٹ بھیجتی ہے۔"
      ],
      "courier": [
        "تصدیق شدہ آرڈرز کو خودکار طور پر سپورٹڈ کورئیر ورک فلو میں بھیجیں۔",
        "مثال: ایک تصدیق شدہ COD آرڈر کورئیر حوالے کے لیے تیار کیا جاتا ہے۔"
      ],
      "business-email": [
        "اپنے برانڈیڈ ڈومین پر پیشہ ورانہ ای میل بھیجیں اور وصول کریں۔",
        "مثال: sales@acme.com سوالات وصول کرتا ہے اور support@acme.com جواب دیتا ہے۔"
      ]
    },
    "sections": {
      "scale": [
        "لامحدود اسکیلنگ",
        "Trade License اور TIN رکھنے والے کاروبار merchant MFS، بینک یا کارڈ کے ذریعے لامحدود ادائیگیاں وصول کر سکتے ہیں — ڈیجیٹل کامرس کے لیے مکمل طور پر خودکار۔"
      ],
      "personal": [
        "کیا آپ کے پاس Trade License نہیں؟",
        "Personal MFS کے ذریعے ادائیگیاں وصول کرنا شروع کریں، اپنی ڈیجیٹل شناخت بنائیں، اور بغیر غیر ضروری پیچیدگی کے ای کامرس شروع کریں۔"
      ],
      "physical": [
        "فزیکل شاپ اور آن لائن",
        "ڈیجیٹل ریکارڈ رکھیں اور اپنی فزیکل شاپ یا آفس سے براہ راست QR ادائیگی کی سپورٹ کے ساتھ آن لائن فروخت کریں۔"
      ]
    },
    "ticker": "1. Personal MFS: Trade License یا TIN نہ رکھنے والے صارفین کے لیے۔ ڈیجیٹل اور فزیکل مصنوعات فروخت کریں اور ایڈوانس ادائیگیاں قبول کریں۔ • 2. Merchant MFS/Bank/Card: لائسنس یافتہ تاجروں کے لیے۔ لامحدود ادائیگیاں وصول کریں اور ڈیجیٹل و فزیکل مصنوعات بیچیں۔ • 3. Bangla QR: فزیکل دکانوں میں QR ادائیگیاں قبول کریں اور آن لائن فروخت کے دوران ڈیجیٹل ریکارڈ رکھیں۔"
  },
  "it": {
    "hero": [
      [
        "MecoPay è una soluzione e-commerce completa —",
        "con potenti gateway di pagamento",
        "e un generatore di siti no-code."
      ],
      [
        "Usa il tuo sito personalizzato o",
        "il nostro sito no-code con API e link",
        "e accetta pagamenti tramite link di pagamento sui social media."
      ],
      [
        "Crea un sito in pochi clic,",
        "aggiungi un dominio personalizzato,",
        "e costruisci la tua identità digitale."
      ],
      [
        "Ricevi ordini automatizzati dai social media",
        "con un AI Agent Chatbot",
        "(per gli utenti del sito no-code)."
      ],
      [
        "Aggiungi un'API del corriere alla nostra piattaforma,",
        "conferma gli ordini con un clic,",
        "e inviali direttamente al corriere."
      ]
    ],
    "features": {
      "no-code-website": [
        "Crea e pubblica siti e-commerce, formativi, blog o di news senza programmare.",
        "Esempio: pubblica una landing page e un post prodotto dalla dashboard del venditore del corso."
      ],
      "custom-domain": [
        "Collega il tuo dominio e costruisci un’identità digitale professionale con instradamento più veloce.",
        "Esempio: il tuo negozio è su www.acme.com invece che su un sottodominio della piattaforma."
      ],
      "capi": [
        "Invia eventi di conversione lato server per una misurazione affidabile delle campagne.",
        "Esempio: un evento di acquisto viene inviato dal server alla piattaforma pubblicitaria."
      ],
      "personal-mfs": [
        "Automatizza la verifica dei pagamenti Personal MFS supportati.",
        "Esempio: un pagamento Personal MFS viene associato all’ordine sul sito."
      ],
      "local-gateway": [
        "Collega metodi di pagamento locali per clienti regionali.",
        "Esempio: un acquirente locale completa il pagamento tramite un gateway regionale."
      ],
      "international-gateway": [
        "Collega metodi di pagamento internazionali per clienti in tutto il mondo.",
        "Esempio: un acquirente estero completa il pagamento con un metodo globale."
      ],
      "notifications": [
        "Invia aggiornamenti su pagamenti e ordini a clienti e commercianti.",
        "Esempio: il successo del pagamento genera una notifica al commerciante e un aggiornamento al cliente."
      ],
      "courier": [
        "Inserisci automaticamente gli ordini confermati nel flusso di lavoro del corriere supportato.",
        "Esempio: un ordine COD confermato viene preparato per la consegna al corriere."
      ],
      "business-email": [
        "Invia e ricevi email professionali sul tuo dominio brandizzato.",
        "Esempio: sales@acme.com riceve richieste e support@acme.com risponde."
      ]
    },
    "sections": {
      "scale": [
        "Scalabilità illimitata",
        "Le aziende con Trade License e TIN possono ricevere pagamenti illimitati tramite merchant MFS, banca o carta — completamente automatizzati per il commercio digitale."
      ],
      "personal": [
        "Non hai una Trade License?",
        "Inizia a ricevere pagamenti con Personal MFS, crea la tua identità digitale e avvia l'e-commerce senza complessità inutili."
      ],
      "physical": [
        "Negozio fisico e online",
        "Conserva registrazioni digitali e vendi online dal tuo negozio fisico o ufficio con supporto al pagamento diretto QR."
      ]
    },
    "ticker": "1. Personal MFS: per utenti senza Trade License o TIN. Vendi prodotti digitali e fisici e accetta pagamenti anticipati. • 2. Merchant MFS/Bank/Card: per commercianti con licenza. Ricevi pagamenti illimitati e vendi prodotti digitali e fisici. • 3. Bangla QR: accetta pagamenti QR nei negozi fisici e conserva registrazioni digitali mentre vendi online."
  },
  "ta": {
    "hero": [
      [
        "MecoPay ஒரு முழுமையான ஈ-காமர்ஸ் தீர்வாக உள்ளது—",
        "வலுவான கட்டண கேட்வேகளுடன்",
        "குறியீடு எழுதாமல் இணையதளம் உருவாக்கும் கருவியுடன்."
      ],
      [
        "உங்கள் தனிப்பட்ட இணையதளத்தைப் பயன்படுத்துங்கள் அல்லது",
        "எங்கள் no-code இணையதளம் APIகள் மற்றும் இணைப்புகள் மூலம்",
        "சோஷியல் மீடியா கட்டண இணைப்புகளின் மூலம் கட்டணங்கள் ஏற்றுகொள்ளுங்கள்."
      ],
      [
        "சில கிளிக்குகளில் இணையதளம் உருவாக்குங்கள்,",
        "தனிப்பட்ட டொமெய்ன் இணைக்கவும்,",
        "மற்றும் உங்கள் டிஜிட்டல் அடையாளத்தை உருவாக்குங்கள்."
      ],
      [
        "சோஷியல் மீடியாவிலிருந்து தானாக வரும் ஆர்டர்களை பெறுங்கள்",
        "AI Agent Chatbot மூலம்",
        "(no-code இணையதளம் பயனர்களுக்காக)."
      ],
      [
        "எமது மேடையில் ஒரு குரியர் API ஐச் சேர்க்கவும்,",
        "ஆர்டர்களை ஒரு கிளிக்கில் உறுதிசெய்யவும்,",
        "மற்றும் அவற்றை நேரடியாக குரியருக்கு அனுப்பவும்."
      ]
    ],
    "features": {
      "no-code-website": [
        "குறியீடு எழுதாமே ஈ-காமர்ஸ், கல்வி, வலைப்பதிவு அல்லது செய்திகள் இணையதளங்களை உருவாக்கி வெளியிடுங்கள்.",
        "உதாரணம்: கோர்ஸ் விற்பனையாளரின் டாஷ்போர்டில் இருந்து லேண்டிங் பக்கம் மற்றும் தயாரிப்பு பதிவை வெளியிடுங்கள்."
      ],
      "custom-domain": [
        "உங்கள் சொந்த டொமெய்னைப் இணைத்து வேகமான ரூட்டிங்குடன் தொழில்முறை டிஜிட்டல் அடையாளத்தை உருவாக்குங்கள்.",
        "உதாரணம்: உங்கள் கடை ஒரு மேடையின் துணை-டொமெய்ன் அல்லாமல் www.acme.com இல் இயங்கும்."
      ],
      "capi": [
        "நம்பகமான பிரச்சார அளவீட்டுக்காக மாற்ற (conversion) நிகழ்வுகளை சர்வர்-பக்கமாக அனுப்புங்கள்.",
        "உதாரணம்: ஒரு கொள்முதல் நிகழ்வு சர்வரிலிருந்து விளம்பர மேடைக்கு அனுப்பப்படுகிறது."
      ],
      "personal-mfs": [
        "ஆதரிக்கப்பட்ட தனிப்பட்ட MFS கட்டண சரிபார்ப்புகளை தானியக்கமாக செயல்படுத்துங்கள்.",
        "உதாரணம்: ஒரு தனிப்பட்ட MFS கட்டணம் இணையதள ஆர்டருடன் பொருத்தப்படுகிறது."
      ],
      "local-gateway": [
        "பிராந்திய வாடிக்கையாளர்களுக்காக உள்ளூர் கட்டண முறைகளை இணைக்கவும்.",
        "உதாரணம்: ஒரு உள்ளூர் வாங்குபவர் பிராந்திய கேட்வேவினூடே கட்டணம் செலுத்தி வாங்கலை முடிக்கிறார்."
      ],
      "international-gateway": [
        "உலகமெங்கும் உள்ள வாடிக்கையாளர்களுக்காக சர்வதேச கட்டண முறைகளை இணைக்கவும்.",
        "உதாரணம்: வெளிநாட்டு வாங்குபவர் ஒரு சூழ்நிலைய உலகளாவிய முறையால் வாங்கலை முடிக்கிறார்."
      ],
      "notifications": [
        "கட்டணம் மற்றும் ஆர்டர் அப்டேட்களை வாடிக்கையாளர்களுக்கும் வணிகருக்கும் அனுப்புங்கள்.",
        "உதாரணம்: கட்டணம் வெற்றியடைந்தால் வணிகருக்கு அறிவிப்பு மற்றும் வாடிக்கையாளருக்கு அப்டேட் அனுப்பப்படும்."
      ],
      "courier": [
        "உறுதி செய்யப்பட்ட ஆர்டர்களை ஆதரிக்கப்படும் குரியர் வேலைபோக்குக்கு தானாக அனுப்புங்கள்.",
        "உதாரணம்: COD உறுதி செய்யப்பட்ட ஆர்டர் குரியருக்கு ஒப்படைக்க தயாராக்கப்படுகிறது."
      ],
      "business-email": [
        "உங்கள் சொந்த பிராண்டு டொமெய்னில் தொழில்முறை மின்னஞ்சலை அனுப்பவும், பெறவும்.",
        "உதாரணம்: sales@acme.com விசாரிப்புகளைப் பெறுகிறது மற்றும் support@acme.com பதிலளிக்கிறது."
      ]
    },
    "sections": {
      "scale": [
        "வரம்பற்ற விரிவாக்கம்",
        "Trade License மற்றும் TIN உள்ள வணிகங்கள் merchant MFS, வங்கி அல்லது கார்டு மூலம் வரம்பற்ற கட்டணங்களைப் பெறலாம் — டிஜிட்டல் வணிகத்திற்காக முழுமையாக தானியக்கமாக்கப்பட்டது."
      ],
      "personal": [
        "Trade License இல்லையா?",
        "Personal MFS மூலம் கட்டணங்களைப் பெற தொடங்குங்கள், உங்கள் டிஜிட்டல் அடையாளத்தை உருவாக்குங்கள், மற்றும் தேவையற்ற சிக்கல்களைத் தவிர்த்து ஈ-காமர்ஸை ஆரம்பியுங்கள்."
      ],
      "physical": [
        "பிரத்யேக கடை மற்றும் ஆன்லைன்",
        "உங்கள் உடல்நிலை கடை அல்லது அலுவலகத்திலிருந்து நேரடியாக QR கட்டண ஆதரவைப் பயன்படுத்தி ஆன்லைனில் விற்பனை செய்து டிஜிட்டல் பதிவுகளை பராமரிக்கவும்."
      ]
    },
    "ticker": "1. Personal MFS: Trade License அல்லது TIN இல்லாத பயனர்களுக்காக. டிஜிட்டல் மற்றும் உடல் பொருட்களை விற்பனை செய்து முன் கட்டணங்களை ஏற்றுக்கொள்ளுங்கள். • 2. Merchant MFS/Bank/Card: உரிமம் பெறுகிய வணிகர்களுக்காக. வரம்பற்ற கட்டணங்களைப் பெற்றுக் கொண்டு டிஜிட்டல் மற்றும் உடல் பொருட்களை விற்பனை செய்யலாம். • 3. Bangla QR: உள்ளூர் கடைகளில் QR கட்டணங்களை ஏற்றுக்கொண்டு ஆன்லைனில் விற்பனை செய்யும்போது டிஜிட்டல் பதிவுகளை வைத்திருக்கவும்."
  },
  "te": {
    "hero": [
      [
        "MecoPay పూర్తి ఈ‑కామర్స్ పరిష్కారం—",
        "శక్తివంతమైన చెల్లింపుల గేట్వేలతో",
        "మరియు కోడ్ అవసరం లేని వెబ్‌సైట్ బిల్డర్."
      ],
      [
        "మీ స్వంత కస్టమ్ వెబ్‌సైట్‌ను ఉపయోగించండి లేదా",
        "APIలు మరియు లింకులతో మా కోడ్ అవసరం లేని వెబ్‌సైట్‌ను ఉపయోగించి",
        "సోషియల్ మీడియాలో చెల్లింపు లింకుల ద్వారా చెల్లింపులను స్వీకరించండి."
      ],
      [
        "కొద్ది క్లిక్‌లలో వెబ్‌సైట్‌ను సృష్టించండి,",
        "కస్టమ్ డొమైన్ జతచేయండి,",
        "మరియు మీ డిజిటల్ గుర్తింపును నిర్మించండి."
      ],
      [
        "సోషియల్ మీడియా నుండి ఆటోమెటెడ్ ఆర్డర్లు స్వీకరించండి",
        "AI Agent Chatbot ద్వారా",
        "(నో‑కోడ్ వెబ్‌సైట్ వినియోగదారుల కోసం)."
      ],
      [
        "మన ప్లాట్‌ఫామ్‌కు ఒక కరియర్ API జోడించండి,",
        "ఒక క్లిక్‌లో ఆర్డర్‌లను నిర్ధారించండి,",
        "మరియు వాటిని నేరుగా కరియర్‌కు పంపండి."
      ]
    ],
    "features": {
      "no-code-website": [
        "కోడ్ లేకుండా ఈ‑కామర్స్, విద్య, బ్లాగ్ లేదా న్యూస్ సైట్లను సృష్టించి ప్రచురించండి.",
        "ఉదాహరణ: కోర్స్ విక్రేత డాష్‌బోర్డ్ నుంచి ల్యాండింగ్ పేజ్ మరియు ఉత్పత్తి పోస్ట్‌ను ప్రచురించండి."
      ],
      "custom-domain": [
        "మీ స్వంత డొమెయిన్‌ను కనెక్ట్ చేసి వేగవంతమైన రౌటింగ్‌తో ప్రొఫెషనల్ డిజిటల్ గుర్తింపును రూపొందించండి.",
        "ఉదాహరణ: మీ స్టోర్ ఫ్లాట్‌ఫాం సబ్‌డొమెయిన్ బదులుగా www.acme.com పై నడుస్తుంది."
      ],
      "capi": [
        "నమ్మదగిన ప్రచార కొలత కోసం కన్వర్షన్ ఈవెంట్స్‌ను సర్వర్‑సైడ్ నుంచి పంపండి.",
        "ఉదాహరణ: ఒక కొనుగోలు ఈవెంట్ సర్వర్ నుంచి యాడ్ ప్లాట్‌ఫారమ్‌కి పంపబడుతుంది."
      ],
      "personal-mfs": [
        "సపోర్ట్ చేయబడిన పర్సనల్ MFS చెల్లింపు ధృవీకరణను ఆటోమెట్ చేయండి.",
        "ఉదాహరణ: ఒక పర్సనల్ MFS చెల్లింపు వెబ్‌సైట్ ఆర్డర్‌కు మ్యాచవుతుంది."
      ],
      "local-gateway": [
        "ప్రాంతీయ ఖాతాదారుల కోసం స్థానిక చెల్లింపు పద్ధతులను కనెక్ట్ చేయండి.",
        "ఉదాహరణ: ఒక స్థానిక కొనుగోలుదారు ప్రాంతీయ గేట్వే ద్వారా చెక్ఔట్ పూర్తి చేస్తాడు."
      ],
      "international-gateway": [
        "ప్రపంచవ్యాప్త ఖాతాదారుల కోసం అంతర్జాతీయ చెల్లింపు పద్ధతులను కలపండి.",
        "ఉదాహరణ: ఒక విదేశీ కొనుగోలుదారు గ్లోబల్ పద్ధతితో చెక్ఔట్ పూర్తి చేస్తాడు."
      ],
      "notifications": [
        "చెల్లింపు మరియు ఆర్డర్ అప్డేట్‌లను గ్రాహకులకు మరియు వ్యాపారులకు పంపండి.",
        "ఉదాహరణ: చెల్లింపు విజయమైతే వ్యాపారికి అలెర్ట్ మరియు గ్రాహకుడికి అప్డేట్ పంపబడుతుంది."
      ],
      "courier": [
        "నిర్ధారించిన ఆర్డర్లను సపోర్టెడ్ కరియర్ వర్క్‌ఫ్లోలో ఆటోమేటిగ్గా పంపండి.",
        "ఉదాహరణ: నిర్ధారించిన COD ఆర్డర్‌ను కరియర్ హస్తాంతరణకు సిద్ధం చేస్తారు."
      ],
      "business-email": [
        "మీ బ్రాండెడ్ డొమైన్‌పై ప్రొఫెషనల్ ఇమెయిల్స్ పంపండి మరియు స్వీకరించండి.",
        "ఉదాహరణ: sales@acme.com కు విచారణలు వస్తాయి మరియు support@acme.com స్పందిస్తుంది."
      ]
    },
    "sections": {
      "scale": [
        "అసీమిత విస్తరణ",
        "Trade License మరియు TIN ఉన్న వ్యాపారాలు merchant MFS, బ్యాంక్ లేదా కార్డ్ ద్వారా అసీమిత చెల్లింపులను స్వీకరించగలవు — డిజిటల్ కామర్స్ కోసం సంపూర్ణంగా ఆటోమెటెడ్."
      ],
      "personal": [
        "Trade License లేదా?",
        "Personal MFSతో చెల్లింపులు అందుకోవడం మొదలు పెట్టండి, మీ డిజిటల్ గుర్తింపుని సృష్టించండి, మరియు అనవసర జఠిలత లేకుండా ఈ‑కామర్స్ ప్రారంభించండి."
      ],
      "physical": [
        "భౌతిక దుకాణం మరియు ఆన్‌లైన్",
        "డిజిటల్ రికార్డులను ఉంచి, డైరెక్ట్ QR చెల్లింపు మద్దతుతో మీ భౌతిక షాప్ లేదా కార్యాలయం నుంచి ఆన్‌లైన్‌లో విక్రయించండి."
      ]
    },
    "ticker": "1. Personal MFS: Trade License లేదా TIN లేని వినియోగదారుల కోసం. డిజిటల్ మరియు ఫిజికల్ ఉత్పత్తులను అమ్మండి మరియు ముందస్తు చెల్లింపులను స్వీకరించండి. • 2. Merchant MFS/Bank/Card: లైసెన్సైన వ్యాపారుల కోసం. అసీమిత చెల్లింపులను స్వీకరించి డిజిటల్ మరియు ఫిజికల్ ఉత్పత్తులను అమ్మండి. • 3. Bangla QR: భౌతిక దుకాణాలలో QR చెల్లింపులను స్వీకరించండి మరియు ఆన్‌లైన్ అమ్మకాల సమయంలో డిజిటల్ రికార్డులను ఉంచుకోండి."
  },
  "nl": {
    "hero": [
      [
        "MecoPay is een complete e-commerceoplossing —",
        "met krachtige betalingsgateways",
        "en een no-code websitebouwer."
      ],
      [
        "Gebruik uw eigen website of",
        "onze no-code website met API's en links",
        "en accepteer betalingen via betaallinks op sociale media."
      ],
      [
        "Maak in een paar klikken een website,",
        "koppel een eigen domein,",
        "en bouw uw digitale identiteit."
      ],
      [
        "Ontvang geautomatiseerde bestellingen vanaf sociale media",
        "met een AI Agent Chatbot",
        "(voor gebruikers van de no-code website)."
      ],
      [
        "Voeg een koerier-API toe aan ons platform,",
        "bevestig bestellingen met één klik,",
        "en stuur ze rechtstreeks naar de koerier."
      ]
    ],
    "features": {
      "no-code-website": [
        "Maak en publiceer e-commerce-, educatie-, blog- of nieuwssites zonder te programmeren.",
        "Voorbeeld: publiceer een landingspagina en een productpost vanuit het dashboard van de cursusverkoper."
      ],
      "custom-domain": [
        "Koppel uw eigen domein en bouw een professionele digitale identiteit met snellere routering.",
        "Voorbeeld: uw winkel draait op www.acme.com in plaats van een subdomein van het platform."
      ],
      "capi": [
        "Verzend conversie-events server-side voor betrouwbare campagne‑meting.",
        "Voorbeeld: een aankoop-event wordt vanaf de server naar het advertentieplatform gestuurd."
      ],
      "personal-mfs": [
        "Automatiseer verificatie van ondersteunde persoonlijke MFS-betalingen.",
        "Voorbeeld: een persoonlijke MFS-betaling wordt gekoppeld aan de websitebestelling."
      ],
      "local-gateway": [
        "Koppel lokale betaalmethodes voor regionale klanten.",
        "Voorbeeld: een lokale koper rondt de betaling af via een regionale gateway."
      ],
      "international-gateway": [
        "Koppel internationale betaalmethodes voor klanten wereldwijd.",
        "Voorbeeld: een buitenlandse koper rondt de betaling af met een wereldwijde methode."
      ],
      "notifications": [
        "Stuur betaal- en bestelupdates naar klanten en handelaars.",
        "Voorbeeld: een succesvolle betaling activeert een waarschuwing naar de handelaar en een update naar de klant."
      ],
      "courier": [
        "Stuur bevestigde bestellingen automatisch naar een ondersteund koerierswerkproces.",
        "Voorbeeld: een bevestigde COD-bestelling wordt klaargemaakt voor overdracht aan de koerier."
      ],
      "business-email": [
        "Verstuur en ontvang professionele e-mails op uw eigen merkdomein.",
        "Voorbeeld: sales@acme.com ontvangt vragen en support@acme.com beantwoordt ze."
      ]
    },
    "sections": {
      "scale": [
        "Onbeperkte schaalbaarheid",
        "Bedrijven met een Trade License en TIN kunnen onbeperkt betalingen ontvangen via merchant MFS, bank of kaart — volledig geautomatiseerd voor digitale handel."
      ],
      "personal": [
        "Geen Trade License?",
        "Begin betalingen te ontvangen met Personal MFS, creëer uw digitale identiteit en start met e-commerce zonder onnodige complexiteit."
      ],
      "physical": [
        "Fysieke winkel en online",
        "Houd digitale administratie bij en verkoop online vanuit uw fysieke winkel of kantoor met directe QR-betalingsondersteuning."
      ]
    },
    "ticker": "1. Personal MFS: voor gebruikers zonder Trade License of TIN. Verkoop digitale en fysieke producten en accepteer vooruitbetalingen. • 2. Merchant MFS/Bank/Card: voor gelicentieerde merchants. Ontvang onbeperkte betalingen en verkoop digitale en fysieke producten. • 3. Bangla QR: accepteer QR-betalingen in fysieke winkels en houd digitale administratie bij terwijl u online verkoopt."
  },
  "th": {
    "hero": [
      [
        "MecoPay เป็นโซลูชันอีคอมเมิร์ซครบวงจร—",
        "พร้อมเกตเวย์การชำระเงินที่ทรงพลัง",
        "และตัวสร้างเว็บไซต์แบบไม่ต้องเขียนโค้ด"
      ],
      [
        "ใช้งานได้ทั้งเว็บไซต์ของคุณเองหรือ",
        "เว็บไซต์แบบไม่ต้องเขียนโค้ดของเราพร้อม API และลิงก์",
        "และรับชำระเงินผ่านลิงก์ชำระเงินบนโซเชียลมีเดีย"
      ],
      [
        "สร้างเว็บไซต์ได้ในไม่กี่คลิก,",
        "ผูกโดเมนของคุณได้ทันที,",
        "และสร้างตัวตนดิจิทัลของคุณ"
      ],
      [
        "รับคำสั่งซื้ออัตโนมัติจากโซเชียลมีเดีย",
        "ด้วย AI Agent Chatbot",
        "(สำหรับผู้ใช้เว็บไซต์แบบไม่ต้องเขียนโค้ด)."
      ],
      [
        "เชื่อมต่อ API ของผู้ให้บริการขนส่งเข้ากับแพลตฟอร์มของเรา,",
        "ยืนยันคำสั่งซื้อได้ด้วยคลิกเดียว,",
        "และส่งต่อไปยังผู้ให้บริการขนส่งทันที"
      ]
    ],
    "features": {
      "no-code-website": [
        "สร้างและเผยแพร่เว็บไซต์อีคอมเมิร์ซ, การศึกษา, บล็อก หรือข่าวสารโดยไม่ต้องเขียนโค้ด.",
        "ตัวอย่าง: เผยแพร่หน้าแลนดิ้งเพจและโพสต์สินค้าจากแดชบอร์ดผู้ขายคอร์ส"
      ],
      "custom-domain": [
        "เชื่อมต่อโดเมนของคุณเองและสร้างตัวตนดิจิทัลที่เป็นมืออาชีพพร้อมการเชื่อมต่อที่เร็วขึ้น.",
        "ตัวอย่าง: ร้านของคุณทำงานที่ www.acme.com แทนที่จะใช้ซับโดเมนของแพลตฟอร์ม"
      ],
      "capi": [
        "ส่งเหตุการณ์การแปลงผลแบบฝั่งเซิร์ฟเวอร์เพื่อการวัดผลแคมเปญที่เชื่อถือได้.",
        "ตัวอย่าง: เหตุการณ์การซื้อถูกส่งจากเซิร์ฟเวอร์ไปยังแพลตฟอร์มโฆษณา"
      ],
      "personal-mfs": [
        "ตรวจยืนยันการชำระเงินผ่าน Personal MFS ที่ระบบรองรับแบบอัตโนมัติ.",
        "ตัวอย่าง: การชำระด้วย Personal MFS ถูกแมตช์กับคำสั่งซื้อบนเว็บไซต์"
      ],
      "local-gateway": [
        "เชื่อมต่อช่องทางการชำระเงินท้องถิ่นสำหรับลูกค้าในภูมิภาค.",
        "ตัวอย่าง: ผู้ซื้อในประเทศทำการชำระเงินผ่านเกตเวย์ภูมิภาค"
      ],
      "international-gateway": [
        "เชื่อมต่อช่องทางการชำระเงินระหว่างประเทศสำหรับลูกค้าทั่วโลก.",
        "ตัวอย่าง: ผู้ซื้อจากต่างประเทศชำระเงินด้วยวิธีการระดับโลก"
      ],
      "notifications": [
        "ส่งการแจ้งเตือนการชำระเงินและสถานะคำสั่งซื้อถึงลูกค้าและผู้ค้า.",
        "ตัวอย่าง: การชำระเงินสำเร็จทำให้ระบบแจ้งเตือนผู้ค้าและอัปเดตลูกค้า"
      ],
      "courier": [
        "ส่งคำสั่งซื้อที่ยืนยันแล้วเข้าสู่กระบวนการของผู้ให้บริการขนส่งที่รองรับโดยอัตโนมัติ.",
        "ตัวอย่าง: คำสั่งซื้อ COD ที่ยืนยันแล้วถูกเตรียมสำหรับส่งมอบให้ผู้ให้บริการขนส่ง"
      ],
      "business-email": [
        "ส่งและรับอีเมลเชิงธุรกิจบนโดเมนแบรนด์ของคุณเอง.",
        "ตัวอย่าง: sales@acme.com รับคำถาม และ support@acme.com ตอบกลับ"
      ]
    },
    "sections": {
      "scale": [
        "ขยายได้ไม่จำกัด",
        "ธุรกิจที่มี Trade License และ TIN สามารถรับการชำระเงินไม่จำกัดผ่าน merchant MFS, ธนาคาร หรือบัตร — อัตโนมัติเต็มรูปแบบสำหรับพาณิชย์ดิจิทัล."
      ],
      "personal": [
        "ไม่มี Trade License?",
        "เริ่มรับการชำระด้วย Personal MFS สร้างตัวตนดิจิทัล และเริ่มต้นอีคอมเมิร์ซโดยไม่ยุ่งยาก"
      ],
      "physical": [
        "หน้าร้านจริงและออนไลน์",
        "เก็บบันทึกดิจิทัลและขายออนไลน์จากร้านหรือสำนักงานจริงของคุณ พร้อมรองรับการชำระด้วย QR โดยตรง."
      ]
    },
    "ticker": "1. Personal MFS: สำหรับผู้ใช้ที่ไม่มี Trade License หรือ TIN ขายสินค้าดิจิทัลและสินค้าจริง และรับชำระเงินล่วงหน้า. • 2. Merchant MFS/Bank/Card: สำหรับผู้ค้าที่มีใบอนุญาต รับการชำระเงินได้ไม่จำกัดและขายทั้งสินค้าดิจิทัลและสินค้าจริง. • 3. Bangla QR: รับชำระด้วย QR ในร้านจริงและเก็บบันทึกดิจิทัลพร้อมขายออนไลน์."
  },
  "uk": {
    "hero": [
      [
        "MecoPay — це комплексне рішення для електронної комерції —",
        "з потужними платіжними шлюзами",
        "і конструктором сайтів без коду."
      ],
      [
        "Використовуйте власний сайт або",
        "наш сайт-будівник без коду з API та посиланнями",
        "і приймайте платежі через платіжні посилання у соціальних мережах."
      ],
      [
        "Створіть сайт за кілька кліків,",
        "підключіть власний домен,",
        "і сформуйте свою цифрову ідентичність."
      ],
      [
        "Отримуйте автоматизовані замовлення із соцмереж",
        "за допомогою AI Agent Chatbot",
        "(для користувачів сайту-будівника без коду)."
      ],
      [
        "Додайте API кур'єра на нашу платформу,",
        "підтверджуйте замовлення в один клік,",
        "і відправляйте їх безпосередньо кур'єру."
      ]
    ],
    "features": {
      "no-code-website": [
        "Створюйте та публікуйте інтернет-магазини, освітні ресурси, блоги або новинні сайти без програмування.",
        "Приклад: опублікуйте лендінг та пост із продуктом з панелі продавця курсів."
      ],
      "custom-domain": [
        "Підключіть власний домен і сформуйте професійну цифрову ідентичність з більш швидкою маршрутизацією.",
        "Приклад: ваш магазин працює на www.acme.com замість піддомену платформи."
      ],
      "capi": [
        "Надсилайте події конверсій із сервера для надійного вимірювання рекламних кампаній.",
        "Приклад: подія покупки надсилається з сервера на рекламну платформу."
      ],
      "personal-mfs": [
        "Автоматизуйте верифікацію підтримуваних особистих MFS‑платежів.",
        "Приклад: особистий MFS‑платіж зіставляється з замовленням на сайті."
      ],
      "local-gateway": [
        "Підключайте локальні способи оплати для регіональних клієнтів.",
        "Приклад: місцевий покупець завершує оплату через регіональний шлюз."
      ],
      "international-gateway": [
        "Підключайте міжнародні методи оплати для клієнтів по всьому світу.",
        "Приклад: покупець з-за кордону завершує оплату за допомогою глобального методу."
      ],
      "notifications": [
        "Надсилайте оновлення про платежі та замовлення клієнтам і продавцям.",
        "Приклад: успішна оплата викликає сповіщення продавця та оновлення для клієнта."
      ],
      "courier": [
        "Автоматично передавайте підтверджені замовлення у підтримуваний кур'єрський робочий процес.",
        "Приклад: підтверджене замовлення COD готується до передачі кур'єру."
      ],
      "business-email": [
        "Надсилайте й отримуйте професійну електронну пошту на власному брендованому домені.",
        "Приклад: sales@acme.com отримує запити, а support@acme.com відповідає."
      ]
    },
    "sections": {
      "scale": [
        "Необмежене масштабування",
        "Підприємства з Trade License та TIN можуть отримувати необмежену кількість платежів через merchant MFS, банк або картку — повністю автоматизовано для цифрової торгівлі."
      ],
      "personal": [
        "Немає Trade License?",
        "Почніть приймати платежі через Personal MFS, створіть свою цифрову ідентичність та розпочніть електронну торгівлю без зайвої складності."
      ],
      "physical": [
        "Фізичний магазин і онлайн",
        "Ведіть цифрові записи та продавайте онлайн із фізичного магазину або офісу з підтримкою прямих QR‑платежів."
      ]
    },
    "ticker": "1. Personal MFS: для користувачів без Trade License або TIN. Продавайте цифрові та фізичні товари та приймайте передоплати. • 2. Merchant MFS/Bank/Card: для ліцензованих продавців. Отримуйте необмежену кількість платежів і продавайте цифрові та фізичні товари. • 3. Bangla QR: приймайте QR‑платежі у фізичних магазинах і ведіть цифровий облік під час онлайн‑продажів."
  },
  "vi": {
    "hero": [
      [
        "MecoPay là một giải pháp thương mại điện tử toàn diện —",
        "với các cổng thanh toán mạnh mẽ",
        "và trình tạo website không cần mã."
      ],
      [
        "Sử dụng website tùy chỉnh của bạn hoặc",
        "website không cần mã của chúng tôi với API và liên kết",
        "và chấp nhận thanh toán qua liên kết thanh toán trên mạng xã hội."
      ],
      [
        "Tạo website chỉ trong vài cú nhấp,",
        "thêm tên miền tùy chỉnh,",
        "và xây dựng nhận diện kỹ thuật số của bạn."
      ],
      [
        "Nhận đơn hàng tự động từ mạng xã hội",
        "với AI Agent Chatbot",
        "(dành cho người dùng website không cần mã)."
      ],
      [
        "Thêm API chuyển phát vào nền tảng của chúng tôi,",
        "xác nhận đơn chỉ với một cú nhấp,",
        "và gửi thẳng tới đơn vị chuyển phát."
      ]
    ],
    "features": {
      "no-code-website": [
        "Tạo và xuất bản trang bán hàng, giáo dục, blog hoặc tin tức mà không cần lập trình.",
        "Ví dụ: xuất bản một trang đích và bài đăng sản phẩm từ bảng điều khiển người bán khóa học."
      ],
      "custom-domain": [
        "Kết nối tên miền riêng và xây dựng nhận diện kỹ thuật số chuyên nghiệp với định tuyến nhanh hơn.",
        "Ví dụ: cửa hàng của bạn chạy trên www.acme.com thay vì subdomain của nền tảng."
      ],
      "capi": [
        "Gửi sự kiện chuyển đổi từ phía máy chủ để đo lường chiến dịch đáng tin cậy.",
        "Ví dụ: một sự kiện mua hàng được gửi từ máy chủ tới nền tảng quảng cáo."
      ],
      "personal-mfs": [
        "Tự động hóa xác minh thanh toán Personal MFS được hỗ trợ.",
        "Ví dụ: thanh toán Personal MFS được đối soát với đơn hàng trên website."
      ],
      "local-gateway": [
        "Kết nối phương thức thanh toán địa phương cho khách hàng trong vùng.",
        "Ví dụ: khách hàng trong nước hoàn tất thanh toán qua cổng khu vực."
      ],
      "international-gateway": [
        "Kết nối phương thức thanh toán quốc tế cho khách hàng toàn thế giới.",
        "Ví dụ: khách hàng nước ngoài hoàn tất thanh toán bằng phương thức toàn cầu."
      ],
      "notifications": [
        "Gửi cập nhật thanh toán và đơn hàng tới khách hàng và người bán.",
        "Ví dụ: khi thanh toán thành công, người bán nhận cảnh báo và khách hàng nhận thông báo."
      ],
      "courier": [
        "Đưa các đơn đã xác nhận vào quy trình chuyển phát được hỗ trợ một cách tự động.",
        "Ví dụ: một đơn COD đã được xác nhận được chuẩn bị để bàn giao cho đơn vị chuyển phát."
      ],
      "business-email": [
        "Gửi và nhận email chuyên nghiệp trên tên miền thương hiệu riêng của bạn.",
        "Ví dụ: sales@acme.com nhận yêu cầu và support@acme.com phản hồi."
      ]
    },
    "sections": {
      "scale": [
        "Mở rộng không giới hạn",
        "Các doanh nghiệp có Trade License và TIN có thể nhận thanh toán không giới hạn qua merchant MFS, ngân hàng hoặc thẻ — hoàn toàn tự động cho thương mại số."
      ],
      "personal": [
        "Không có Trade License?",
        "Bắt đầu nhận thanh toán bằng Personal MFS, tạo nhận diện kỹ thuật số và bắt đầu kinh doanh trực tuyến mà không rườm rà."
      ],
      "physical": [
        "Cửa hàng vật lý và trực tuyến",
        "Lưu hồ sơ điện tử và bán trực tuyến ngay từ cửa hàng hoặc văn phòng vật lý của bạn với hỗ trợ thanh toán QR trực tiếp."
      ]
    },
    "ticker": "1. Personal MFS: dành cho người dùng không có Trade License hoặc TIN. Bán sản phẩm kỹ thuật số và vật lý và chấp nhận thanh toán trước. • 2. Merchant MFS/Bank/Card: dành cho thương nhân có giấy phép. Nhận thanh toán không giới hạn và bán sản phẩm kỹ thuật số lẫn vật lý. • 3. Bangla QR: chấp nhận thanh toán QR tại cửa hàng vật lý và lưu hồ sơ điện tử khi bán trực tuyến."
  },
  "pl": {
    "hero": [
      [
        "MecoPay to kompletne rozwiązanie e‑commerce —",
        "z potężnymi bramkami płatności",
        "i kreatorem stron bez kodowania."
      ],
      [
        "Użyj własnej strony",
        "naszego kreatora bez kodowania z API i linkami",
        "i akceptuj płatności za pomocą linków płatniczych w mediach społecznościowych."
      ],
      [
        "Stwórz stronę w kilku kliknięciach,",
        "dodaj własną domenę,",
        "i zbuduj swoją cyfrową tożsamość."
      ],
      [
        "Odbieraj automatyczne zamówienia z mediów społecznościowych",
        "przy pomocy AI Agent Chatbot",
        "(dla użytkowników stron bez kodowania)."
      ],
      [
        "Dodaj API kuriera do naszej platformy,",
        "potwierdzaj zamówienia jednym kliknięciem,",
        "i wysyłaj je bezpośrednio do kuriera."
      ]
    ],
    "features": {
      "no-code-website": [
        "Twórz i publikuj sklepy internetowe, serwisy edukacyjne, blogi lub serwisy informacyjne bez kodowania.",
        "Przykład: opublikuj stronę docelową i wpis produktu z panelu sprzedawcy kursu."
      ],
      "custom-domain": [
        "Podłącz własną domenę i zbuduj profesjonalną tożsamość cyfrową z szybszym routowaniem.",
        "Przykład: Twój sklep działa pod adresem www.acme.com zamiast na subdomenie platformy."
      ],
      "capi": [
        "Wysyłaj zdarzenia konwersji po stronie serwera, aby rzetelnie mierzyć kampanie.",
        "Przykład: zdarzenie zakupu jest wysyłane z serwera do platformy reklamowej."
      ],
      "personal-mfs": [
        "Automatyzuj weryfikację obsługiwanych płatności Personal MFS.",
        "Przykład: płatność Personal MFS jest dopasowywana do zamówienia na stronie."
      ],
      "local-gateway": [
        "Podłącz lokalne metody płatności dla klientów regionalnych.",
        "Przykład: lokalny klient finalizuje zakup przez regionalną bramkę płatności."
      ],
      "international-gateway": [
        "Podłącz międzynarodowe metody płatności dla klientów na całym świecie.",
        "Przykład: klient z zagranicy finalizuje zakup z użyciem globalnej metody."
      ],
      "notifications": [
        "Wysyłaj powiadomienia o płatnościach i zamówieniach do klientów i sprzedawców.",
        "Przykład: powodzenie płatności wyzwala alert dla sprzedawcy i powiadomienie dla klienta."
      ],
      "courier": [
        "Automatycznie przekazuj potwierdzone zamówienia do obsługi wspieranego kuriera.",
        "Przykład: potwierdzone zamówienie COD jest przygotowywane do przekazania kurierowi."
      ],
      "business-email": [
        "Wysyłaj i odbieraj profesjonalne e‑maile na własnej domenie z marką.",
        "Przykład: sales@acme.com otrzymuje zapytania, a support@acme.com odpowiada."
      ]
    },
    "sections": {
      "scale": [
        "Nieograniczona skalowalność",
        "Firmy z Trade License i TIN mogą otrzymywać nieograniczone płatności przez Merchant MFS, bank lub kartę — w pełni zautomatyzowane dla handlu cyfrowego."
      ],
      "personal": [
        "Nie masz Trade License?",
        "Zacznij odbierać płatności dzięki Personal MFS, stwórz swoją cyfrową tożsamość i rozpocznij e‑commerce bez zbędnej komplikacji."
      ],
      "physical": [
        "Sklep stacjonarny i sprzedaż online",
        "Prowadź cyfrową dokumentację i sprzedawaj online ze sklepu lub biura, korzystając z bezpośredniego wsparcia płatności QR."
      ]
    },
    "ticker": "1. Personal MFS: dla użytkowników bez Trade License lub TIN. Sprzedawaj produkty cyfrowe i fizyczne oraz przyjmuj płatności z góry. • 2. Merchant MFS/Bank/Card: dla zarejestrowanych sprzedawców. Odbieraj nieograniczone płatności i sprzedawaj produkty cyfrowe i fizyczne. • 3. Bangla QR: akceptuj płatności QR w sklepach stacjonarnych i prowadź cyfrowe zapisy przy sprzedaży online."
  },
  "el": {
    "hero": [
      [
        "Το MecoPay είναι μια ολοκληρωμένη λύση ηλεκτρονικού εμπορίου —",
        "με ισχυρές πύλες πληρωμών",
        "και έναν κατασκευαστή ιστοσελίδων χωρίς κωδικοποίηση."
      ],
      [
        "Χρησιμοποιήστε την προσαρμοσμένη ιστοσελίδα σας ή",
        "την ιστοσελίδα χωρίς κωδικοποίηση μας με API και συνδέσμους",
        "και δεχτείτε πληρωμές μέσω συνδέσμων πληρωμών στα μέσα κοινωνικής δικτύωσης."
      ],
      [
        "Δημιουργήστε μια ιστοσελίδα με λίγα κλικ,",
        "προσθέστε ένα προσαρμοσμένο domain,",
        "και χτίστε την ψηφιακή σας ταυτότητα."
      ],
      [
        "Λάβετε αυτοματοποιημένες παραγγελίες από μέσα κοινωνικής δικτύωσης",
        "με ένα AI Agent Chatbot",
        "(για χρήστες της ιστοσελίδας χωρίς κωδικοποίηση)."
      ],
      [
        "Προσθέστε ένα courier API στην πλατφόρμα μας,",
        "επιβεβαιώστε παραγγελίες με ένα κλικ,",
        "και στείλτε τις απευθείας στον courier."
      ]
    ],
    "features": {
      "no-code-website": [
        "Δημιουργήστε και δημοσιεύστε ιστότοπους ηλεκτρονικού εμπορίου, εκπαίδευσης, blog ή ειδήσεων χωρίς κωδικοποίηση.",
        "Παράδειγμα: δημοσιεύστε μια σελίδα προορισμού και μια ανάρτηση προϊόντος από τον πίνακα ελέγχου του πωλητή του μαθήματος."
      ],
      "custom-domain": [
        "Συνδέστε το δικό σας domain και δημιουργήστε μια επαγγελματική ψηφιακή ταυτότητα με ταχύτερη δρομολόγηση.",
        "Παράδειγμα: το κατάστημά σας φιλοξενείται στο www.acme.com αντί για υποτομέα της πλατφόρμας."
      ],
      "capi": [
        "Στείλτε συμβάντα μετατροπής από τον διακομιστή (server-side) για αξιόπιστη μέτρηση καμπανιών.",
        "Παράδειγμα: ένα συμβάν αγοράς αποστέλλεται από τον διακομιστή στην πλατφόρμα διαφημίσεων."
      ],
      "personal-mfs": [
        "Αυτοματοποιήστε την επαλήθευση πληρωμών Personal MFS που υποστηρίζονται.",
        "Παράδειγμα: μια πληρωμή Personal MFS αντιστοιχίζεται με την παραγγελία στην ιστοσελίδα."
      ],
      "local-gateway": [
        "Συνδέστε τοπικές μεθόδους πληρωμής για πελάτες της περιοχής.",
        "Παράδειγμα: ένας τοπικός αγοραστής ολοκληρώνει την αγορά μέσω μιας περιφερειακής πύλης πληρωμών."
      ],
      "international-gateway": [
        "Συνδέστε διεθνείς μεθόδους πληρωμής για πελάτες σε όλο τον κόσμο.",
        "Παράδειγμα: ένας αγοραστής από το εξωτερικό ολοκληρώνει την πληρωμή με μια παγκόσμια μέθοδο."
      ],
      "notifications": [
        "Αποστέλλετε ενημερώσεις για πληρωμές και παραγγελίες σε πελάτες και εμπόρους.",
        "Παράδειγμα: η επιβεβαίωση πληρωμής ενεργοποιεί ειδοποίηση προς τον έμπορο και ενημέρωση προς τον πελάτη."
      ],
      "courier": [
        "Στείλτε επιβεβαιωμένες παραγγελίες αυτόματα σε υποστηριζόμενη ροή εργασίας κούριερ.",
        "Παράδειγμα: μια επιβεβαιωμένη παραγγελία COD προετοιμάζεται για παράδοση στον κούριερ."
      ],
      "business-email": [
        "Στείλτε και λαμβάνετε επαγγελματικά email στο δικό σας domain με εταιρικό brand.",
        "Παράδειγμα: το sales@acme.com λαμβάνει ερωτήσεις και το support@acme.com απαντά."
      ]
    },
    "sections": {
      "scale": [
        "Απεριόριστη Κλιμάκωση",
        "Επιχειρήσεις με Trade License και TIN μπορούν να λαμβάνουν απεριόριστες πληρωμές μέσω Merchant MFS, τραπεζών ή καρτών — πλήρως αυτοματοποιημένα για το ψηφιακό εμπόριο."
      ],
      "personal": [
        "Δεν έχετε Trade License;",
        "Ξεκινήστε να λαμβάνετε πληρωμές με Personal MFS, δημιουργήστε την ψηφιακή σας ταυτότητα και αρχίστε το ηλεκτρονικό εμπόριο χωρίς περιττές επιπλοκές."
      ],
      "physical": [
        "Φυσικό Κατάστημα και Διαδικτυακά",
        "Κρατήστε ψηφιακά αρχεία και πουλήστε online από το φυσικό σας κατάστημα ή γραφείο με άμεση υποστήριξη πληρωμών QR."
      ]
    },
    "ticker": "1. Personal MFS: για χρήστες χωρίς Trade License ή TIN. Πουλήστε ψηφιακά και φυσικά προϊόντα και δεχτείτε προπληρωμές. • 2. Merchant MFS/Bank/Card: για αδειοδοτημένους εμπόρους. Λάβετε απεριόριστες πληρωμές και πουλήστε ψηφιακά και φυσικά προϊόντα. • 3. Bangla QR: δεχτείτε πληρωμές QR σε φυσικά καταστήματα και κρατήστε ψηφιακά αρχεία ενώ πωλείτε online."
  },
  "ne": {
    "hero": [
      [
        "MecoPay एक पूर्ण ई-कर्मस समाधान हो—",
        "शक्तिशाली भुक्तानी गेटवेहरूसहित",
        "र एक नो-कोड वेबसाइट बिल्डरसहित।"
      ],
      [
        "आफ्नो कस्टम वेबसाइट प्रयोग गर्नुहोस् वा",
        "हाम्रो नो-कोड वेबसाइट जुन API र लिंकहरूसहित छ",
        "र सामाजिक मिडिया भुक्तानी लिंकमार्फत भुक्तानी स्वीकार गर्नुहोस्।"
      ],
      [
        "केही क्लिकमै वेबसाइट बनाउनुहोस्,",
        "कस्टम डोमेन थप्नुहोस्,",
        "र आफ्नो डिजिटल पहिचान निर्माण गर्नुहोस्।"
      ],
      [
        "सामाजिक मिडियाबाट स्वचालित अर्डर प्राप्त गर्नुहोस्",
        "AI Agent Chatbot सँग",
        "(नो-कोड वेबसाइट प्रयोगकर्ताका लागि)।"
      ],
      [
        "हाम्रो प्लेटफर्ममा कूरियर API थप्नुहोस्,",
        "एक क्लिकमा अर्डर पुष्टि गर्नुहोस्,",
        "र तिनीहरूलाई सिधै कूरियरमा पठाउनुहोस्।"
      ]
    ],
    "features": {
      "no-code-website": [
        "कोडिङ बिना इ-कर्मस, शिक्षा, ब्लग वा समाचार साइटहरू सिर्जना र प्रकाशित गर्नुहोस्।",
        "उदाहरण: कोर्स बेच्ने ड्यासबोर्डबाट ल्यान्डिङ पेज र उत्पादन पोस्ट प्रकाशित गर्नुहोस्।"
      ],
      "custom-domain": [
        "आफ्नो डोमेन जडान गरेर तीव्र राउटिङसहित पेशेवर डिजिटल पहिचान बनाउनुहोस्।",
        "उदाहरण: तपाईंको स्टोर प्लेटफर्मको सबडोमेनको सट्टा www.acme.com मा चल्छ।"
      ],
      "capi": [
        "रिलायबल क्याम्पेन मापनका लागि सर्भर-साइडबाट कन्भर्सन इभेन्टहरू पठाउनुहोस्।",
        "उदाहरण: एउटा खरिद घटना सर्भरबाट विज्ञापन प्लेटफर्ममा पठाइन्छ।"
      ],
      "personal-mfs": [
        "समर्थित Personal MFS भुक्तानी प्रमाणीकरण स्वचालित गर्नुहोस्।",
        "उदाहरण: एउटा Personal MFS भुक्तानी वेबसाइट अर्डरसँग मेल खाइन्छ।"
      ],
      "local-gateway": [
        "क्षेत्रीय ग्राहकहरूको लागि स्थानीय भुक्तानी विधिहरू जडान गर्नुहोस्।",
        "उदाहरण: एउटा स्थानीय खरीददार एक क्षेत्रीय गेटवेमार्फत चेकआउट पूरा गर्छ।"
      ],
      "international-gateway": [
        "विश्वभरिका ग्राहकहरूको लागि अन्तर्राष्ट्रिय भुक्तानी विधिहरू जडान गर्नुहोस्।",
        "उदाहरण: एउटा विदेशी खरीददार ग्लोबल विधि प्रयोग गरी चेकआउट पूरा गर्छ।"
      ],
      "notifications": [
        "भुक्तानी र अर्डर अपडेटहरू ग्राहक र व्यापारीहरूलाई पठाउनुहोस्।",
        "उदाहरण: भुक्तानी सफल हुँदा व्यापारीलाई सूचित र ग्राहकलाई अपडेट गरिन्छ।"
      ],
      "courier": [
        "पुष्टि भएका अर्डरहरूलाई स्वतः समर्थित कूरियर कार्यप्रवाहमा पठाउनुहोस्।",
        "उदाहरण: एउटा पुष्टि गरिएको COD अर्डर कूरियर हस्तान्तरणका लागि तयार गरिन्छ।"
      ],
      "business-email": [
        "आफ्नो ब्रान्डेड डोमेनमा पेशेवर ईमेल पठाउन र प्राप्त गर्नुस्।",
        "उदाहरण: sales@acme.com ले सोधपुछ प्राप्त गर्छ र support@acme.com जवाफ दिन्छ।"
      ]
    },
    "sections": {
      "scale": [
        "Unlimited Scaling",
        "Trade License र TIN भएका व्यवसायहरूले merchant MFS, बैंक वा कार्डमार्फत असीमित भुक्तानी प्राप्त गर्न सक्छन्—डिजिटल व्यापारका लागि पूर्ण रूपमा स्वचालित।"
      ],
      "personal": [
        "No Trade License?",
        "Personal MFS द्वारा भुक्तानी प्राप्त गर्न सुरु गर्नुहोस्, आफ्नो डिजिटल पहिचान बनाउनुहोस्, र अनावश्यक जटिलता बिना इ-कर्मस सुरु गर्नुहोस्।"
      ],
      "physical": [
        "Physical Shop and Online",
        "डिजिटल रेकर्ड राख्नुहोस् र आफ्नो भौतिक पसल वा कार्यालयबाट सिधा QR भुक्तानी समर्थनका साथ अनलाइन बेच्नुहोस्।"
      ]
    },
    "ticker": "1. Personal MFS: Trade License वा TIN नभएका प्रयोगकर्ताहरूका लागि। डिजिटल र भौतिक उत्पादनहरू बेच्नुहोस् र अग्रिम भुक्तानी स्वीकार गर्नुहोस्। • 2. Merchant MFS/Bank/Card: लाइसेन्स प्राप्त व्यापारीहरूका लागि। असीमित भुक्तानी प्राप्त गर्नुहोस् र डिजिटल तथा भौतिक उत्पादन बिक्री गर्नुहोस्। • 3. Bangla QR: भौतिक पसलहरूमा QR भुक्तानी स्वीकार गर्नुहोस् र अनलाइन बिक्री गर्दा डिजिटल रेकर्ड राख्नुहोस्।"
  },
  "he": {
    "hero": [
      [
        "MecoPay הוא פתרון מסחר אלקטרוני מלא —",
        "עם שערי תשלום חזקים",
        "ובונה אתרים ללא קוד."
      ],
      [
        "השתמש באתר המותאם שלך או",
        "באתר ללא קוד שלנו עם API וקישורים",
        "וקבל תשלומים דרך קישורי תשלום ברשתות החברתיות."
      ],
      [
        "צור אתר בכמה קליקים,",
        "הוסף דומיין מותאם אישית,",
        "ובנה את הזהות הדיגיטלית שלך."
      ],
      [
        "קבל הזמנות אוטומטיות מהרשתות החברתיות",
        "עם AI Agent Chatbot",
        "(למשתמשי אתר ללא קוד)."
      ],
      [
        "הוסף API של חברת שליחויות לפלטפורמה שלנו,",
        "אשר הזמנות בלחיצה אחת,",
        "ושלח אותן ישירות לחברת השליחויות."
      ]
    ],
    "features": {
      "no-code-website": [
        "צור ופרסם אתרי מסחר אלקטרוני, חינוך, בלוגים או אתרי חדשות — ללא קידוד.",
        "דוגמה: פרסם דף נחיתה ופוסט מוצר מלוח הבקרה של מוכר הקורסים."
      ],
      "custom-domain": [
        "חבר דומיין משלך ובנה זהות דיגיטלית מקצועית עם ניתוב מהיר יותר.",
        "דוגמה: החנות שלך רצה על www.acme.com במקום תת-דומיין של הפלטפורמה."
      ],
      "capi": [
        "שלח אירועי המרה בצד השרת (CAPI) למדידה אמינה של קמפיינים.",
        "דוגמה: אירוע רכישה נשלח מהשרת לפלטפורמת הפרסום."
      ],
      "personal-mfs": [
        "אוטומט את אימות תשלומי MFS אישיים הנתמכים.",
        "דוגמה: תשלום MFS אישי מותאם להזמנה באתר."
      ],
      "local-gateway": [
        "חבר שיטות תשלום מקומיות ללקוחות אזוריים.",
        "דוגמה: קונה מקומי משלים תשלום דרך שער תשלום אזורי."
      ],
      "international-gateway": [
        "חבר שיטות תשלום בינלאומיות ללקוחות ברחבי העולם.",
        "דוגמה: קונה מחו\"ל משלים תשלום באמצעות שיטה גלובלית."
      ],
      "notifications": [
        "שלח עדכונים על תשלום והזמנות ללקוחות ולסוחרים.",
        "דוגמה: הצלחת תשלום מפעילה התראה לסוחר ועדכון ללקוח."
      ],
      "courier": [
        "שלח הזמנות מאושרות אל זרימת העבודה של חברת השליחויות הנתמכת באופן אוטומטי.",
        "דוגמה: הזמנת COD מאושרת מוכנה למסירה לחברת השליחויות."
      ],
      "business-email": [
        "שלח וקבל דוא\"ל מקצועי על דומיין המותג שלך.",
        "דוגמה: sales@acme.com מקבל פניות ו-support@acme.com עונה."
      ]
    },
    "sections": {
      "scale": [
        "התרחבות בלתי מוגבלת",
        "עסקים בעלי Trade License ו-TIN יכולים לקבל תשלומים ללא הגבלה דרך Merchant MFS, בנק או כרטיס — עם אוטומציה מלאה למסחר הדיגיטלי."
      ],
      "personal": [
        "אין Trade License?",
        "התחל לקבל תשלומים עם Personal MFS, צור זהות דיגיטלית והתחל מסחר אלקטרוני ללא סיבוכים מיותרים."
      ],
      "physical": [
        "חנות פיזית ומכירות אונליין",
        "שמור רשומות דיגיטליות ומכור אונליין מהחנות או המשרד הפיזי שלך עם תמיכה בתשלומי QR ישירים."
      ]
    },
    "ticker": "1. Personal MFS: למשתמשים ללא Trade License או TIN. מכור מוצרים דיגיטליים ופיזיים וקבל תשלומים מראש. • 2. Merchant MFS/Bank/Card: לסוחרים מורשים. קבל תשלומים ללא הגבלה ומכור מוצרים דיגיטליים ופיזיים. • 3. Bangla QR: קבל תשלומי QR בחנויות פיזיות ושמור רשומות דיגיטליות תוך כדי מכירה אונליין."
  },
  "da": {
    "hero": [
      [
        "MecoPay er en komplet e-handelsløsning —",
        "med kraftfulde betalingsgateways",
        "og en no-code-webstedsbygger."
      ],
      [
        "Brug dit eget websted eller",
        "vores no-code-websted med APIs og links",
        "og modtag betalinger via betalingslinks på sociale medier."
      ],
      [
        "Opret et websted på få klik,",
        "tilføj et tilpasset domæne,",
        "og opbyg din digitale identitet."
      ],
      [
        "Modtag automatiserede ordrer fra sociale medier",
        "med en AI Agent Chatbot",
        "(for brugere af no-code-websteder)."
      ],
      [
        "Tilføj en courier API til vores platform,",
        "bekræft ordrer med ét klik,",
        "og send dem direkte til leveringsfirmaet."
      ]
    ],
    "features": {
      "no-code-website": [
        "Opret og publicer e-handels-, undervisnings-, blog- eller nyhedssider uden kodning.",
        "Eksempel: publicer en landingsside og et produktindlæg fra kursussælgerens kontrolpanel."
      ],
      "custom-domain": [
        "Tilslut dit eget domæne og skab en professionel digital identitet med hurtigere routing.",
        "Eksempel: din butik kører på www.acme.com i stedet for et platform-underdomæne."
      ],
      "capi": [
        "Send konverteringsbegivenheder server-side for pålidelig kampagnemåling.",
        "Eksempel: en købsbegivenhed sendes fra serveren til annonceplatformen."
      ],
      "personal-mfs": [
        "Automatiser verifikation af understøttede Personal MFS-betalinger.",
        "Eksempel: en Personal MFS-betaling bliver matchet med webstedsordren."
      ],
      "local-gateway": [
        "Tilslut lokale betalingsmetoder for regionale kunder.",
        "Eksempel: en lokal køber gennemfører betalingen via en regional gateway."
      ],
      "international-gateway": [
        "Tilslut internationale betalingsmetoder for kunder over hele verden.",
        "Eksempel: en udenlandsk køber gennemfører betalingen med en global metode."
      ],
      "notifications": [
        "Send betalings- og ordreopdateringer til kunder og handlende.",
        "Eksempel: betalingssucces udløser en notifikation til forhandleren og en opdatering til kunden."
      ],
      "courier": [
        "Send bekræftede ordrer automatisk ind i en understøttet courier-workflow.",
        "Eksempel: en bekræftet COD-ordre klargøres til overlevering til courier."
      ],
      "business-email": [
        "Send og modtag professionel e-mail på dit eget brandede domæne.",
        "Eksempel: sales@acme.com modtager henvendelser, og support@acme.com svarer."
      ]
    },
    "sections": {
      "scale": [
        "Ubegrænset skalering",
        "Virksomheder med en Trade License og TIN kan modtage ubegrænsede betalinger via merchant MFS, bank eller kort — fuldt automatiseret til digital handel."
      ],
      "personal": [
        "Ingen Trade License?",
        "Begynd at modtage betalinger med Personal MFS, opret din digitale identitet, og start e-handel uden unødig kompleksitet."
      ],
      "physical": [
        "Fysisk butik og online",
        "Bevar digitale optegnelser og sælg online fra din fysiske butik eller dit kontor med direkte QR-betalingsunderstøttelse."
      ]
    },
    "ticker": "1. Personal MFS: for brugere uden Trade License eller TIN. Sælg digitale og fysiske produkter og modtag forudbetalinger. • 2. Merchant MFS/Bank/Card: for licenserede handlende. Modtag ubegrænsede betalinger og sælg digitale og fysiske produkter. • 3. Bangla QR: accepter QR-betalinger i fysiske butikker og bevare digitale optegnelser, mens du sælger online."
  },
  "sv": {
    "hero": [
      [
        "MecoPay är en komplett e-handelslösning—",
        "med kraftfulla betalningsgateways",
        "och en webbplatsbyggare utan kod."
      ],
      [
        "Använd din egen webbplats eller",
        "vår webbplats utan kod med API:er och länkar",
        "och ta emot betalningar via betalningslänkar i sociala medier."
      ],
      [
        "Skapa en webbplats med några klick,",
        "lägg till en egen domän,",
        "och bygg din digitala identitet."
      ],
      [
        "Ta emot automatiska beställningar från sociala medier",
        "med en AI Agent Chatbot",
        "(för användare av webbplatser utan kod)."
      ],
      [
        "Lägg till ett kurir-API på vår plattform,",
        "bekräfta beställningar med ett klick,",
        "och skicka dem direkt till kuriren."
      ]
    ],
    "features": {
      "no-code-website": [
        "Skapa och publicera e-handels-, utbildnings-, blogg- eller nyhetssajter utan att koda.",
        "Exempel: publicera en landningssida och ett produktinlägg från instrumentpanelen för kurssäljare."
      ],
      "custom-domain": [
        "Koppla din egen domän och bygg en professionell digital identitet med snabbare routing.",
        "Exempel: din butik körs på www.acme.com istället för en plattforms-subdomän."
      ],
      "capi": [
        "Skicka konverteringshändelser från servern för tillförlitlig kampanjmätning.",
        "Exempel: en köp-händelse skickas från servern till annonsplattformen."
      ],
      "personal-mfs": [
        "Automatisera verifiering av stödjda personliga MFS-betalningar.",
        "Exempel: en personlig MFS-betalning matchas mot webbplatsbeställningen."
      ],
      "local-gateway": [
        "Anslut lokala betalningsmetoder för regionala kunder.",
        "Exempel: en lokal köpare slutför kassan via en regional gateway."
      ],
      "international-gateway": [
        "Anslut internationella betalningsmetoder för kunder över hela världen.",
        "Exempel: en utländsk köpare slutför kassan med en global metod."
      ],
      "notifications": [
        "Skicka betalnings- och orderuppdateringar till kunder och handlare.",
        "Exempel: betalningsframgång utlöser en varning till handlaren och en uppdatering till kunden."
      ],
      "courier": [
        "Skicka bekräftade beställningar automatiskt till en stöttad kurirprocess.",
        "Exempel: en bekräftad COD-order förbereds för överlämning till kuriren."
      ],
      "business-email": [
        "Skicka och ta emot professionell e-post på din egen varumärkesdomän.",
        "Exempel: sales@acme.com tar emot förfrågningar och support@acme.com svarar."
      ]
    },
    "sections": {
      "scale": [
        "Obegränsad skalning",
        "Företag med Trade License och TIN kan ta emot obegränsade betalningar via merchant MFS, bank eller kort — helt automatiserat för digital handel."
      ],
      "personal": [
        "Ingen Trade License?",
        "Börja ta emot betalningar med Personal MFS, skapa din digitala identitet och starta e-handel utan onödig komplexitet."
      ],
      "physical": [
        "Fysisk butik och online",
        "Behåll digitala register och sälj online från din fysiska butik eller ditt kontor med direkt stöd för QR-betalningar."
      ]
    },
    "ticker": "1. Personal MFS: för användare utan Trade License eller TIN. Sälj digitala och fysiska produkter och ta emot förskottsbetalningar. • 2. Merchant MFS/Bank/Card: för licensierade handlare. Ta emot obegränsade betalningar och sälj digitala och fysiska produkter. • 3. Bangla QR: ta emot QR-betalningar i fysiska butiker och behåll digitala register samtidigt som du säljer online."
  },
  "si": {
    "hero": [
      [
        "MecoPay සම්පූර්ණ ඉ-කොමර්ස් විසඳුමකි—",
        "ශක්තිමත් ගෙවීම් ගේට්වේ සමඟ",
        "සහ කේත රහිත වෙබ්අඩවි සකස්කරුක්."
      ],
      [
        "ඔබගේ අභිරුචි වෙබ්අඩවිය භාවිතා කරන්න හෝ",
        "API සහ සබැඳි සමඟ අපගේ කේත රහිත වෙබ්අඩවිය භාවිතා කරන්න",
        "සමඟින් සමාජ මාධ්‍ය ගෙවීම් සබැඳි ඔස්සේ ගෙවීම් පිළිගන්න."
      ],
      [
        "කිහිප ක්ලික් වලින් වෙබ්අඩවියක් සාදන්න,",
        "අභිරුචි ඩොමේනයක් එක් කරන්න,",
        "සහ ඔබගේ ඩිජිටල් හැඳුනුම ගොඩනගන්න."
      ],
      [
        "සමාජ මාධ්‍යෙන් ස්වයංක්‍රීය ඇණවුම් ලබා ගන්න",
        "AI Agent Chatbot සමඟ",
        "(කේත රහිත වෙබ්අඩවි භාවිත කරන්නන් සඳහා)."
      ],
      [
        "අපගේ ප්ලැට්ෆෝමයට කුරියර් API එකක් එක් කරන්න,",
        "ඇණවුම් එක් ක්ලික් එකකින් තහවුරු කරන්න,",
        "සෘජුවම කුරියර්ට එවා දෙන්න."
      ]
    ],
    "features": {
      "no-code-website": [
        "කේත රහිතව ඉ-කොමර්ස්, අධ්‍යාපන, බ්ලොග් හෝ පුවත් වෙබ්අඩවි නිර්මාණය කර පළ කරන්න.",
        "උදාහරණයක්: පාඨමාලා විකුණුම්කරුවන්ගේ ඩෑෂ්බෝර්ඩ් එකෙන් ලෑන්ඩිං පිටුවක් සහ නිෂ්පාදන පෝස්ට් එකක් පළ කරන්න."
      ],
      "custom-domain": [
        "ඔබගේම ඩොමේනය සම්බන්ධ කර වේගවත් රවුටින් සමඟ වෘත්තීය ඩිජිටල් හැඳුනුමක් ගොඩනගන්න.",
        "උදාහරණයක්: ඔබගේ වෙළඳසැල පද්ධති උප-ඩොමේනයකට වෙනුවට www.acme.com මත ධාවනය වේ."
      ],
      "capi": [
        "විශ්වාසදායක ප්‍රචාරණ මැනීම සඳහා conversion සිදුවීම් සේවාදායක පැත්තෙන් යවන්න.",
        "උදාහරණයක්: මිලදී ගැනීමේ සිදුවීම සේවාදායකයෙන් දැන්වීම් වේදිකාවට යවනු ලැබේ."
      ],
      "personal-mfs": [
        "සහාය ලබන පෞද්ගලික MFS ගෙවීම් සත්‍යාපනය ස්වයංක්‍රීය කරන්න.",
        "උදාහරණයක්: පෞද්ගලික MFS ගෙවීමක් වෙබ්අඩවියේ ඇණවුමට ගැලපෙන ලෙස සම්බන්ධ කෙරේ."
      ],
      "local-gateway": [
        "දේශීය පාරිභෝගිකයින් සඳහා දේශීය ගෙවීම් ක්‍රම සම්බන්ධ කරන්න.",
        "උදාහරණයක්: දේශීය ගනුදෙනුකරු දේශීය ගේට්වේ එකක් හරහා ගෙවීම් සම්පූර්ණ කරයි."
      ],
      "international-gateway": [
        "ලෝක පුරා පාරිභෝගිකයින් සඳහා ජාත්‍යන්තර ගෙවීම් ක්‍රම සම්බන්ධ කරන්න.",
        "උදාහරණයක්: විදේශගත ගනුදෙනුකරු ගෝලීය ගෙවීම් ක්‍රමයක් හරහා ගෙවීම් සම්පූර්ණ කරයි."
      ],
      "notifications": [
        "ගෙවීම් සහ ඇණවුම් යාවත්කාලීන කිරීම් පාරිභෝගිකයින්ට සහ වෙළඳුන්ට එවන්න.",
        "උදාහරණයක්: ගෙවීම සාර්ථක වූ විට වෙළඳුවට දැනුම්දීමක් සහ පාරිභෝගිකයාට යාවත්කාලීන කිරීමක් සිදුවේ."
      ],
      "courier": [
        "තහවුරු කළ ඇණවුම් සහාය දක්වන කුරියර් වැඩපිළිවෙළට ස්වයංක්‍රීයව යවන්න.",
        "උදාහරණයක්: තහවුරු කළ COD ඇණවුම කුරියර්ට භාරදීමට සූදානම් කෙරේ."
      ],
      "business-email": [
        "ඔබගේම බ්‍රෑන්ඩ් කළ ඩොමේනය මත වෘත්තීය ඊමේල් යවන්න සහ ප්‍රැබලව ලැබිය යුතු ඊමේල් ලබාගන්න.",
        "උදාහරණයක්: sales@acme.com විමසීම් ලබයි සහ support@acme.com පිළිතුරු දේ."
      ]
    },
    "sections": {
      "scale": [
        "අසීමිත විස්තාරය",
        "Trade License සහ TIN ඇති ව්‍යාපාර Merchant MFS, බැංකු හෝ කාඩ් හරහා අසීමිත ගෙවීම් ලබාගත හැක — ඩිජිටල් වාණිජ්‍යය සඳහා සම්පූර්ණයෙන් ස්වයංක්‍රීය."
      ],
      "personal": [
        "Trade License නැද්ද?",
        "Personal MFS භාවිතයෙන් ගෙවීම් ලැබීම ආරම්භ කරන්න, ඔබගේ ඩිජිටල් හැඳුනුම සාදන්න, අවශ්‍ය නොවන සංකීර්ණතා රහිතව ඉ-කොමර්ස් ආරම්භ කරන්න."
      ],
      "physical": [
        "භෞතික වෙළඳසැල සහ ඔන්ලයින්",
        "භෞතික වෙළඳසැල හෝ කාර්යාලයක සිටම QR සෘජු ගෙවීම් සහය සමඟ ඔන්ලයින්ව විකිණීමත් සමඟ ඩිජිටල් වාර්තා තබන්න."
      ]
    },
    "ticker": "1. Personal MFS: Trade License හෝ TIN නොමැති පරිශීලකයින් සඳහා. ඩිජිටල් සහ භෞතික නිෂ්පාදන විකිණීමට සහ පෙරගෙවීම් පිළිගැනීමට හැකියාව. • 2. Merchant MFS/Bank/Card: බලපත්‍රලත් වෙළඳුවන් සඳහා. අසීමිත ගෙවීම් ලබාගෙන ඩිජිටල් හා භෞතික නිෂ්පාදන විකිණිය හැක. • 3. Bangla QR: භෞතික වෙළඳසැල් වල QR ගෙවීම් පිළිගනිමින් ඔන්ලයින්ව විකිණීම සිදුකරන විට ඩිජිටල් වාර්තා රැක ගන්න."
  }
} as const;
